import * as config from './config';
import BaseApp from '@genstackio/react-admin-core/lib/BaseApp';
import useApp from "@genstackio/react-admin-core/lib/hooks/useApp";

function App() {
    return <BaseApp {...useApp(config as any)} />;
}

export default App